module.exports = __webpack_public_path__ + "static/img/angry.0ad2c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/angry.png
// module id = VmzU
// module chunks = 0